import { gql } from '@/__generated__';

export const updateOrderDocument = gql(/* GraphQL */ `
  mutation UpdateOrder($where: OrderWhereUniqueInput!, $data: OrderUpdateInput!) {
    updateOrder(where: $where, data: $data) {
      id
    }
  }
`);

export const upsertOrderAddressDocument = gql(/* GraphQL */ `
  mutation UpsertOrderAddress($orderId: String!, $input: OrderAddressCreateWithoutOrderInput!) {
    upsertOrderAddress(orderId: $orderId, input: $input) {
      id
      address {
        ...OrderAddressDetails
      }
    }
  }
`);

export const updateOrderCustomerDocument = gql(/* GraphQL */ `
  mutation UpdateOrderCustomer($orderId: String!, $input: CustomerCreateInput!) {
    updateOrderCustomer(orderId: $orderId, input: $input) {
      id
      customer {
        ...OrderCustomerDetails
      }
    }
  }
`);

export const updateLineOnOrderDocument = gql(/* GraphQL */ `
  mutation UpdateLineOnOrder($lineId: String!, $input: OrderLineUpdateWithoutOrderInput!) {
    updateLineOnOrder(lineId: $lineId, input: $input) {
      ...OrderLineDetails
    }
  }
`);

export const upsertLineOnOrderDocument = gql(/* GraphQL */ `
  mutation UpsertLineOnOrder($orderId: String!, $input: OrderLineCreateManyOrderInput!) {
    upsertLineOnOrder(orderId: $orderId, input: $input) {
      id
      lines {
        ...OrderLineDetails
      }
    }
  }
`);

export const removeLineFromOrderDocument = gql(/* GraphQL */ `
  mutation RemoveLineFromOrder($lineId: String!, $reason: String!) {
    removeLineFromOrder(lineId: $lineId, reason: $reason) {
      id
      total
      lines {
        ...OrderLineDetails
      }
      cancellations {
        ...OrderCancellationDetails
      }
    }
  }
`);

export const recalculateOrderTotalDocument = gql(/* GraphQL */ `
  mutation RecalculateOrderTotal($orderId: String!) {
    recalculateOrderTotal(orderId: $orderId) {
      id
      total
    }
  }
`);

export const processOrderDocument = gql(/* GraphQL */ `
  mutation ProcessOrder($orderId: String!) {
    processOrder(orderId: $orderId) {
      id
      status
    }
  }
`);

export const createShipmentDocument = gql(/* GraphQL */ `
  mutation CreateShipment($orderId: String!, $count: Int = 1) {
    createShipment(orderId: $orderId, count: $count) {
      ...OrderDetails
    }
  }
`);

export const createShipmentDPDDocument = gql(/* GraphQL */ `
  mutation CreateShipmentDPD($orderId: String!, $count: Int = 1) {
    createShipmentDPD(orderId: $orderId, count: $count) {
      ...OrderDetails
    }
  }
`);

export const deleteShipmentDocument = gql(/* GraphQL */ `
  mutation DeleteShipment($orderId: String!) {
    deleteShipment(orderId: $orderId) {
      ...OrderDetails
    }
  }
`);

export const setIbanTypeDocument = gql(/* GraphQL */ `
  mutation SetIbanType($orderId: String!, $ibanType: String!) {
    setIbanType(orderId: $orderId, ibanType: $ibanType) {
      ...OrderDetails
    }
  }
`);

export const setShippingMethodOnOrderDocument = gql(/* GraphQL */ `
  mutation SetShippingMethodOnOrder($orderId: String!, $shippingMethodId: String!) {
    setShippingMethodOnOrder(orderId: $orderId, shippingMethodId: $shippingMethodId) {
      ...OrderDetails
    }
  }
`);

export const setPaymentMethodOnOrderDocument = gql(/* GraphQL */ `
  mutation SetPaymentMethodOnOrder($orderId: String!, $paymentMethodId: String!) {
    setPaymentMethodOnOrder(orderId: $orderId, paymentMethodId: $paymentMethodId) {
      ...OrderDetails
    }
  }
`);

export const cancelOrderDocument = gql(/* GraphQL */ `
  mutation CancelOrder($orderId: String!, $reason: String) {
    cancelOrder(orderId: $orderId, reason: $reason) {
      id
      ...OrderDetails
    }
  }
`);

export const sendMessageDocument = gql(/* GraphQL */ `
  mutation SendMessage($orderId: String!, $message: String!) {
    sendMessage(orderId: $orderId, message: $message)
  }
`);

export const sendMessagesDocument = gql(/* GraphQL */ `
  mutation SendMessages($orderIds: [String!]!, $message: String!) {
    sendMessages(orderIds: $orderIds, message: $message)
  }
`);

export const issueInvoiceDocument = gql(/* GraphQL */ `
  mutation IssueInvoice($orderId: String!, $shouldSend: Boolean!) {
    issueInvoice(orderId: $orderId, shouldSend: $shouldSend) {
      id
      number
      url
      createdAt
      sent
    }
  }
`);

export const issueInvoicesDocument = gql(/* GraphQL */ `
  mutation IssueInvoices($orderIds: [String!]!) {
    issueInvoices(orderIds: $orderIds)
  }
`);
